import React from 'react';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from 'modules/emergencies/components/ui/containers/logTitleContainer';
import LogIcon from 'modules/emergencies/components/log/LogIcon';
import { getUserName } from 'modules/emergencies/components/ticketsList/ticketsListTable/utils/user';

const AssignedLogTitle = ({ titleData = {}, icon, title }) => {
  const { log } = titleData;
  const userAssigned = getUserName(log.target.data);
  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{title}</TextLog>
      <TextLog color="#54708C">/ {userAssigned}</TextLog>
    </LogTitleContainer>
  );
};

export default AssignedLogTitle;
